export default __webpack_public_path__ + "static/media/Group85.746a4e8a.png";